import {Component, AfterViewInit, EventEmitter, Output} from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import {LanguageService} from '../../services/language.service';
import {TranslateService} from '@ngx-translate/core';

import { ConnectionService } from 'ng-connection-service';
import {UserService} from '../../services/user.service';
import {AuthService} from '../../services/auth.service';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;
  public swithLang = 'fr';
  browserLang;


  options = [
    {name: 'Français', id: 1, code: 'Fr'},
    {name: 'English', id: 2, code: 'En'},
  ];
  currentSelection = {
    code: 'Fr',
    name: 'English'
  };
  status = 'ONLINE';
  isConnected = true;
  cart: any;

  constructor(private modalService: NgbModal,
              private userService: UserService,
              private authService: AuthService,
              private router: Router,
              private languageService: LanguageService, private translate: TranslateService) {
    languageService.selectedLanguage.subscribe(result => {
      this.swithLang = result;
      translate.addLangs(['en', 'fr']);
      translate.setDefaultLang(result);
      // console.log('lan', result);
      translate.use(result);
      this.currentSelection = this.options.find(l => l.code.toLocaleLowerCase() === result.toLocaleLowerCase());
    });
  }


  // This is for Notifications
  notifications: Object[] = [
    {
      btn: 'btn-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      btn: 'btn-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      btn: 'btn-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      btn: 'btn-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  ngAfterViewInit() {
  }

  changeLanguag(lang: any) {
    this.currentSelection = lang;
    this.languageService.selectedLanguage.next(lang.code.toLocaleLowerCase());
  }

  selectedLang() {

    this.translate.use(this.browserLang.match(/fr|en /) ? this.browserLang : 'fr');
  }

  openCart() {
    this.router.navigate(['dashboard/etude/panier']);
  }
}
